var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Kszta\\u0142t_1502",
    d: "M0,0h20v2H0V0z M0,6h20v2H0V6z M0,12h10v2H0V12z M13,21v-9l7,4.5L13,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.109ccff400b32be25323e3541d0903cc.svg";
export { ForwardRef as ReactComponent };